// This file is auto-generated by scripts/set-images-cdn-path.js
// Do not edit this file manually
var IMAGES_CDN_BASE_URLS = {
    development: 'https://reconvert-cdn.com/react-ui-component/development',
    staging: 'https://reconvert-cdn.com/react-ui-component/staging',
    production: 'https://reconvert-cdn.com/react-ui-component/production',
};

export { IMAGES_CDN_BASE_URLS };
//# sourceMappingURL=config.js.map
